




























































































































































































































































































import {
	computed,
	defineComponent,
	nextTick,
	Ref,
	ref,
	watch,
} from '@vue/composition-api';
import { Size, Spacing } from '@front-app/components/constants';
import Vue from '@front-app/vendor/vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import PaddedContent from '@front-app/components/layouts/columns/PaddedContent.vue';
import ScrollingColumn from '@front-app/components/layouts/columns/ScrollingColumn.vue';
import { Routes } from '@front-app/constants/routes';
import LoaderState from '@front-app/components/LoaderState.vue';
import {
	markDiscussionRead,
} from '@front-app/services/GroupsApi/GroupsDiscussionApi';
import {
	Content,
	Contents,
	ContentV2,
	ContentsV2,
	ContentType,
	StoredDiscussionContentItem,
	ReactionType,
} from '@front-app/services/GroupsApi/DiscussionModel';
import { ButtonPalettes } from '@front-app/components/buttons/palettes';
import SimpleCard from '@front-app/components/cards/SimpleCard.vue';
import UserAvatar from '@front-app/components/user/avatar.vue';
import UserLink from '@front-app/components/buttons/UserLink.vue';
import { getUsername } from '@front-app/util/user';
import { CurrentUserStore, UserAvatarStore, UserStore } from '@front-app/store/singletons/User';
import CategoryButton from '@front-app/components/buttons/concrete/CategoryButton.vue';
import CtaButton from '@front-app/components/buttons/CtaButton.vue';
import IconButton from '@front-app/components/buttons/IconButton.vue';
import SimpleDropdown from '@front-app/components/dropdowns/SimpleDropdown.vue';
import PublicLink from '@front-app/components/buttons/PublicLink.vue';
import DiscussionForm from '@front-app/components/discussion/DiscussionForm.vue';
import { GroupsStore } from '@front-app/store/singletons/Groups';
import FollowButton from '@front-app/components/buttons/concrete/FollowButton.vue';
import DenseUserList from '@front-app/components/cards/DenseUserList.vue';
import BaseDivider from '@front-app/components/layouts/BaseDivider.vue';
import CountCard from '@front-app/components/cards/content/CountCard.vue';
import SlidingPanel from '@front-app/components/modals/SlidingPanel.vue';
import NotesList from '@front-app/components/notes/NotesList.vue';
import NoteView from '@front-app/components/notes/NoteView.vue';
import TrSnackbar from '@front-app/components/Snackbar.vue';
import { isNotNullish } from '@front-app/util/types';
import { getNoteStore, MarkMessageReadPayload } from '@front-app/store/modules/note';
import { useAsyncStatus } from '@front-app/hooks/useAsyncStatus';
import { PartialUser } from '@front-app/services/UserApi/UserModel';
import { NoteMessage } from '@front-app/services/NoteApi/NoteModels';
import BackButton from '@front-app/components/buttons/BackButton.vue';
import { CreateNotePayload } from '@front-app/services/NoteApi/NoteApi';
import { useAsyncModal } from '@front-app/hooks/useAsyncModal';
import { VueConstructor } from 'vue';
import {
	canEditDiscussionCategories,
	canEditDiscussionSubject,
	canShareFilesToGroup,
	canUserReplyToDiscussion,
} from '@front-app/util/permission';
import ContentInfoModal from '@front-app/components/cards/content/ContentInfoModal.vue';
import deepEqual from 'deep-equal';
import { trackGroupMessageAction } from '@front-app/services/ActionApi/ActionApi';
import { GroupAuditAction } from '@front-app/services/ActionApi/ActionModel';
import { getGroupContentV2 } from '@front-app/services/GroupsApi/GroupsContentApi';
import { sum } from '@front-app/util/math';
import { syncedRef } from '@front-app/util/reactivity';
import { useDiscussionStore } from '@front-app/store/piniaModules/discussions';
import DiscussionList from '@front-app/components/discussion/DiscussionList.vue';
import { getContentDomId } from '@front-app/components/discussion/util';
import { useDiscussionMessageStore } from '@front-app/store/piniaModules/discussionMessages';
import { useGroupContentStore } from '@front-app/store/piniaModules/groupContent';
import { routeToShareContent, ShareContentPanelState } from '@front-app/modules/group/util/shareContentModal';

const CONTENT_INFO_PANEL_BY_TYPE = {
	[ContentType.FILE]: ContentInfoModal,
	[ContentType.LINK]: ContentInfoModal,
};

const isAttachment = (item: Contents | ContentsV2 | undefined): item is Contents => Boolean(item);

const importEditDiscussionForm = () => import(/* webpackChunkName: "edit-discussion" */ '@front-app/components/discussion/EditDiscussionForm.vue')
	.then((_) => _.default as VueConstructor);

const importCreateNoteForm = () => import(/* webpackChunkName: "create-note" */ '@front-app/components/notes/CreateNoteForm.vue')
	.then((_) => _.default as VueConstructor);

const importFollowersList = () => import(/* webpackChunkName: "discussion-followers" */ '@front-app/components/discussion/FollowersList.vue')
	.then((_) => _.default as VueConstructor);

export default defineComponent({
	components: {
		ScrollingColumn,
		PaddedContent,
		FontAwesomeIcon,
		LoaderState,
		SimpleCard,
		UserLink,
		UserAvatar,
		CategoryButton,
		CtaButton,
		IconButton,
		SimpleDropdown,
		PublicLink,
		DiscussionForm,
		FollowButton,
		DenseUserList,
		BaseDivider,
		CountCard,
		SlidingPanel,
		NotesList,
		NoteView,
		BackButton,
		DiscussionList,
		TrSnackbar,
	},
	props: {
		groupId: {
			type: String,
			required: true,
		},
		discussionId: {
			type: String,
			required: true,
		},
		deeplinkNoteId: {
			type: String,
			default: '',
		},
		deeplinkNoteMessageId: {
			type: String,
			default: '',
		},
		showContent: {
			type: String,
			default: '',
		},
	},
	setup(props, ctx) {
		const getUsernameInternal = (user: PartialUser): string => getUsername(ctx.root.$t.bind(ctx.root), user);
		const group = computed(() => GroupsStore.getInstance().groupById(props.groupId));

		// Discussion list
		const {
			track: trackContentFetch,
			isLoading: isLoadingDiscussion,
		} = useAsyncStatus();
		const content: Ref<null | StoredDiscussionContentItem> = ref(null);
		const fetchDiscussion = async (a: string, b: string | undefined) => {
			if (a === b || a === null) {
				return;
			}
			await trackContentFetch(useDiscussionStore().fetch(props.groupId, props.discussionId));
			const msg = useDiscussionStore().getById(props.discussionId);
			if (msg) {
				content.value = msg;
			}
			await markDiscussionRead(props.discussionId);
		};
		watch(() => props.discussionId, fetchDiscussion, { immediate: true });
		// END Discussion list

		// Edit
		const canEditSubject = computed(() => {
			const groupVal = group.value;
			const { isCsr, currentUser } = CurrentUserStore;
			return groupVal && canEditDiscussionSubject(
				groupVal,
				isCsr.value,
				currentUser.value.id === content.value?.creator.id,
			);
		});
		const canEditCategories = computed(() => {
			const groupVal = group.value;
			const { isCsr, currentUser } = CurrentUserStore;
			return groupVal && canEditDiscussionCategories(
				groupVal,
				isCsr.value,
				currentUser.value.id === content.value?.creator.id,
			);
		});
		const editModal = useAsyncModal('edit-discussion-toggle', importEditDiscussionForm);

		watch(editModal.isModalVisible, (curr, prev) => {
			if (deepEqual(curr, prev) || !props.groupId || !editModal.isModalVisible.value) {
				return;
			}
			trackGroupMessageAction(props.groupId, props.discussionId, GroupAuditAction.VIEW_DISCUSSION_EDIT_PAGE);
		}, { immediate: true });
		// END Edit

		// Follows
		const isFollowing = computed(() => useDiscussionStore().isFollowing(props.discussionId));
		const {
			isLoading: isSubmittingFollow,
			track: trackToggleFollow,
		} = useAsyncStatus();
		const performFollowRequest = async () => {
			trackToggleFollow(useDiscussionStore().toggleFollow(props.discussionId));
		};
		const followers = computed(() => content.value?.metadata.discussion.followers);
		const displayedFollowers = computed(() => {
			const followersArray = content.value?.metadata.discussion.followers;

			if (isFollowing && followersArray) {
				const { currentUser } = CurrentUserStore;

				// Removing the current user from the followers array to avoid duplication
				const rearrangedFollowers = followersArray.filter((follower) => follower.id !== currentUser.value.id);

				// Adding back the current user to the beginning of the followers array in order to always be displayed
				const currentUserAsFollower = followersArray.find((follower) => follower.id === currentUser.value.id);
				if (currentUserAsFollower) {
					rearrangedFollowers?.splice(0, 0, currentUserAsFollower);
				}

				return rearrangedFollowers?.slice(0, 4);
			}

			return followersArray?.slice(0, 4);
		});
		const remainingFollowerCount = computed(() => {
			const followersArray = content.value?.metadata.discussion.followers;
			return followersArray && followersArray.length > 4 ? followersArray.length - 4 : 0;
		});
		const followersModal = useAsyncModal('discussion-followers-toggle', importFollowersList);
		// END Follows

		// Metadata
		const numAttachments = computed(() => (content.value?.metadata.discussion.messages || [])
			.map(useDiscussionMessageStore().getById)
			.filter(isNotNullish)
			.map(({ attachments }) => attachments)
			.filter(isAttachment)
			.map(({ contents }) => contents.length)
			.reduce(sum, 0));
		const numNotes = computed(() => (content.value?.metadata.discussion.messages || [])
			.map(useDiscussionMessageStore().getById)
			.filter(isNotNullish)
			.map((message) => message.numNotes)
			.reduce(sum, 0));
		const scrollToReplyForm = () => {
			const form = document.getElementById('discussionReplyFormElement');
			if (!form) {
				return;
			}
			const el = form.querySelector('.ProseMirror') as null | HTMLTextAreaElement;
			if (el) {
				el.focus();
				el.scrollIntoView();
			}
		};
		const canReply = computed(() => group.value && canUserReplyToDiscussion(group.value, CurrentUserStore.isCsr.value));
		// END Metadata

		// Notes..
		const noteStore = getNoteStore(UserStore.getInstance());
		const selectedMessageIdForNotes = ref('');
		const selectedMessageForNotes = computed(() => content.value?.metadata.discussion.messages.find((id) => id === selectedMessageIdForNotes.value));

		/* List */
		const isViewNotesModalOpen = ref(false);
		const fetchNoteList = (discussionMessageId: string) => {
			noteStore.fetchMetadata(discussionMessageId);
		};
		const viewNoteList = (discussionMessageId: string) => {
			fetchNoteList(discussionMessageId);
			isViewNotesModalOpen.value = true;
			selectedMessageIdForNotes.value = discussionMessageId;
		};
		const isNoteListLoading = computed(() => noteStore.isLoadingMetadata(selectedMessageIdForNotes.value));

		/* Single note */
		const isViewNoteModalOpen = ref(false);
		const selectedNoteId: Ref<string> = ref('');
		const showNote = (noteId: string) => {
			noteStore.fetch(noteId);
			selectedNoteId.value = noteId;
			isViewNoteModalOpen.value = true;
		};
		const currentlySelectedNote = computed(() => noteStore.get(selectedNoteId.value));
		const replyToNote = (newMessage: NoteMessage) => {
			noteStore.reply(newMessage);
		};
		const isSendingInvitations = ref(false);
		const performAddParticipants = async (userIds: string[]) => {
			isSendingInvitations.value = true;
			await noteStore.addParticipants(selectedNoteId.value, userIds);
			isSendingInvitations.value = false;
		};
		const closeViewNoteModal = () => {
			isViewNoteModalOpen.value = false;
			if (!props.groupId && !props.discussionId) {
				return;
			}
			ctx.root.$router.push({
				name: Routes.GROUP_DISCUSSION,
				params: {
					groupId: props.groupId,
					discussionId: props.discussionId,
				},
			});
		};
		const leaveNote = async (noteId: string) => {
			await noteStore.leave(noteId);
			noteStore.remove(noteId);
			const messageId = content.value?.metadata.discussion.messages.find((id) => id === selectedMessageIdForNotes.value);
			if (!messageId) {
				return;
			}
			const message = useDiscussionMessageStore().getById(messageId);
			if (!message) {
				return;
			}
			message.numNotes = Math.max(0, message.numNotes - 1);
			closeViewNoteModal();
		};

		/* Create */
		const {
			isModalVisible: isCreateNoteModalOpen,
			modalView: createNoteComponent,
			closeModal: closeNoteModal,
			showModal: showNoteModal,
		} = useAsyncModal('', importCreateNoteForm);
		const selectedMessageNoteList = computed(() => noteStore.getMetadata(selectedMessageIdForNotes.value));
		const isCreatingNote = ref(false);
		const createNote = async (payload: CreateNotePayload) => {
			isCreatingNote.value = true;
			const noteResult = await noteStore.create(payload);
			const messageId = content.value?.metadata.discussion.messages.find((id) => id === selectedMessageIdForNotes.value);
			if (!messageId) {
				return;
			}
			const message = useDiscussionMessageStore().getById(messageId);
			viewNoteList(selectedMessageIdForNotes.value);
			showNote(noteResult.noteId);
			isCreatingNote.value = false;
			closeNoteModal();
			if (!message) {
				return;
			}
			message.numNotes += 1;
		};

		/* Deeplink */
		const isLoadingDeeplink = ref(false);
		type DeeplinkPropsWatcherResults = string | boolean;
		const checkDeeplink = async (newValues: DeeplinkPropsWatcherResults[]) => {
			const [noteId, noteMessageId, isLoading] = newValues;
			if (
				noteId && noteMessageId && !isLoading && !isLoadingDeeplink.value
			) {
				isLoadingDeeplink.value = true;
				await noteStore.fetchDeeplink(props.deeplinkNoteId, props.deeplinkNoteMessageId);
				isLoadingDeeplink.value = false;
				await nextTick();
				const noteMeta = noteStore.getNoteMetadata(props.deeplinkNoteId);
				document.getElementById(getContentDomId(noteMeta.discussionMessageId))?.scrollIntoView();
				await nextTick();
				isViewNoteModalOpen.value = true;
				selectedMessageIdForNotes.value = noteMeta.discussionMessageId;
				selectedNoteId.value = props.deeplinkNoteId;
			}
		};
		watch([
			computed(() => props.deeplinkNoteId),
			computed(() => props.deeplinkNoteMessageId),
			isLoadingDiscussion,
		], checkDeeplink, { immediate: true });

		const markMessageRead = (noteMessageId: string) => {
			const payload: MarkMessageReadPayload = {
				noteId: selectedNoteId.value,
				noteMessageId,
			};
			noteStore.markMessageRead(payload);
		};
		// END Notes

		// Content info panel
		const groupContentStore = useGroupContentStore();
		const selectedContent = syncedRef(() => groupContentStore.getById(groupContentStore.selectedContentId)).ref;
		const contentListEl: Ref<null | Vue> = ref(null);
		const displayContent = (item: Content | ContentV2) => {
			if (item.type === ContentType.DISCUSSION) {
				return;
			}
			groupContentStore.selectContent(item.id);
		};
		const closeContentModal = () => {
			if (!selectedContent.value) {
				return;
			}

			// Return focus to opener
			const child = contentListEl.value?.$el.querySelector(
				`#${getContentDomId(selectedContent.value.id)} .content-card--clickable_aria-button-internal`,
			) as HTMLButtonElement | undefined;
			if (child) {
				child.focus();
			}

			groupContentStore.selectContent('');
			const q = ctx.root.$route.query;
			ctx.root.$router.push({ query: { ...q, showContent: '' } });
		};
		const routeToContent = (contentItem: ContentV2) => {
			if (selectedContent.value?.id !== contentItem.id) {
				displayContent(contentItem);
			}
			if (contentItem.type !== ContentType.DISCUSSION) {
				const q = ctx.root.$route.query;
				ctx.root.$router.push({ query: { ...q, showContent: contentItem.id } });
			}
		};
		watch(() => props.showContent, async (curr, prev) => {
			if (!curr || curr === prev || selectedContent.value?.id === curr) {
				return;
			}
			const contentItem = await getGroupContentV2(props.groupId, props.showContent);
			groupContentStore.update([contentItem]);
			displayContent(contentItem);
		}, { immediate: true });
		// END Content info panel

		// Attach content
		const toShareContent = computed(() => routeToShareContent(ctx, ShareContentPanelState.FILE, props.discussionId));
		// END Attach content

		const toGroupContent = computed(() => ({ name: Routes.GROUP_CONTENT, params: { groupId: props.groupId } }));

		// Reactions
		const reactToContent = async (contentType: ContentType, contentId: string, reactionType: ReactionType) => {
			await groupContentStore.react(props.groupId, contentType, contentId, reactionType);
		};
		// END Reactions

		// Snackbar
		const isSnackbarDisplayed = ref(false);
		const displaySnackbar = () => {
			isSnackbarDisplayed.value = true;
			setTimeout(() => {
				isSnackbarDisplayed.value = false;
			}, 5000);
		};
		// END Snackbar

		return {
			group,
			// Left side
			toGroupContent,
			// Main discussion
			getUsername: getUsernameInternal,
			getAvatar: UserAvatarStore.get,
			fetchAvatar: UserAvatarStore.fetch,
			// Discussion list
			isLoadingDiscussion,
			content,
			// Edit
			isEditDiscussionModalVisible: editModal.isModalVisible,
			editDiscussionModalView: editModal.modalView,
			editModal,
			canEditCategories,
			canEditSubject,
			// Follows
			isFollowing,
			isSubmittingFollow,
			performFollowRequest,
			followers,
			displayedFollowers,
			remainingFollowerCount,
			isFollowersModalVisible: followersModal.isModalVisible,
			followersModalView: followersModal.modalView,
			followersModal,
			// Metadata
			numAttachments,
			numNotes,
			scrollToReplyForm,
			canReply,
			// Constants
			Size,
			Spacing,
			ContentType,
			ButtonPalettes,
			// General notes
			selectedMessageIdForNotes,
			selectedMessageForNotes,
			// Create note
			isCreateNoteModalOpen,
			isCreatingNote,
			createNote,
			createNoteComponent,
			closeNoteModal,
			showNoteModal,
			// View note list
			viewNoteList,
			fetchNoteList,
			isNoteListLoading,
			isViewNotesModalOpen,
			selectedMessageNoteList,
			// View note
			isViewNoteModalOpen,
			selectedNoteId,
			showNote,
			currentlySelectedNote,
			replyToNote,
			performAddParticipants,
			isSendingInvitations,
			closeViewNoteModal,
			leaveNote,
			getNoteMetadata: noteStore.getNoteMetadata,
			markMessageRead,
			// Deeplink
			isLoadingDeeplink,
			// Sharing
			canShareFilesToGroup,
			toShareContent,
			// Content info panel
			selectedContent,
			contentListEl,
			closeContentModal,
			routeToContent,
			CONTENT_INFO_PANEL_BY_TYPE,
			// Reactions
			reactToContent,
			// Snackbar
			isSnackbarDisplayed,
			displaySnackbar,
		};
	},
});
